import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import GridTable, { fldInfsProps } from "@/js/common/ui/GridTable";
import Modal from "@/js/common/ui/modal/Modal";
import AdminGridStyle from "@/js/common/ui/style/AdminGridStyle";
import Util from "@/js/common/Util";
import React from "react";
import DatePickerBox from "@/js/common/ui/input/DatePickerBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import TextBox from "@/js/common/ui/input/TextBox";
import DialogTitleBar from "../../common/DialogTitleBar";
import MbrasNewMngDialog from "./dialog/MbrasNewMngDialog";
import * as Atom from "@/js/common/Atom";
import { useRecoilValue } from "recoil";


const MbrasNewMng = () => {
    const userInfo = useRecoilValue(Atom.userInfo);


    // 검색 조건
    const [keyword   , setKeyword   ] = React.useState(""); // 성명
    const [searchAtrzSttsCd, setSearchAtrzSttsCd] = React.useState(""); // 상태
    const [upOgnzCd,    _setUpOgnzCd] = React.useState<string>(userInfo.upOgnzCd); // 상위조직코드(본부)
    const [ognzCd,      _setOgnzCd] = React.useState<string>(userInfo.ognzCd); // 조직코드(지부)
    const [ocptTypeCd, setOcptTypeCd     ] = React.useState(""); // 직종
    const [sttDt     , setSttDt     ] = React.useState(""); // 작성일자 시작일
    const [endDt     , setEndDt     ] = React.useState(""); // 작성일자 종료일

    const [dataArr   , setDataArr   ] = React.useState<[]>([]); // 조합원 검색 List

    const [modalOpen, setModalOpen] = React.useState(false); // 모달 열림 여부
    const [mbrasId  , setMbrasId] = React.useState<string>("");   // 조합원 ID
    const [mbrasAtrzDocId  , setMbrasAtrzDocId] = React.useState<string>("");   // 조합원 ID
    const [callTime , setCallTime ] = React.useState<Date>(new Date()); // Refresh용

    // GridTable 컬럼 정의
    const fldInfs: fldInfsProps[] = [
        { type: "seq"                      , width:  50, headAlign: "center", dataAlign: "center", label: "No."                            },
        { type: "text", fldNm: "mbrasId"   , width:  120, headAlign: "center", dataAlign: "center", label: "조합원번호"                     },
        { type: "text", fldNm: "mbrasNm"   , width: 90, headAlign: "center", dataAlign: "center", label: "성명"                            },
        { type: "text", fldNm: "atrzSttsNm", width: 100, headAlign: "center", dataAlign: "center", label: "상태"                           },
        { type: "text", fldNm: "upOgnzNm"  , width: 120, headAlign: "center", dataAlign: "center", label: "본부"                           },
        { type: "text", fldNm: "ognzNm"    , width: 120, headAlign: "center", dataAlign: "center", label: "지부"                           },
        { type: "text", fldNm: "wtjrNm"    , width: 160, headAlign: "center", dataAlign: "center", label: "관내"                           },
        { type: "text", fldNm: "ocptTypeNm", width: 110, headAlign: "center", dataAlign: "center", label: "직종"                           },
        { type: "text", fldNm: "crtDt"     , width: 110, headAlign: "center", dataAlign: "center", label: "작성일자"                       },
    ];


    React.useEffect(() => {
        // 작성일자 검색 조건 확인
        if (Util.isNotEmpty(sttDt) && Util.isNotEmpty(endDt)) {
            if (sttDt > endDt) {
                AppContext.openAlert({ 
                    title: "작성일자 검색 조건 확인", 
                    msg: "작성일자의 검색 시작일자가 종료일자보다 느립니다.", 
                    icon: "warning" 
                }); 
                setEndDt("")
                return;
            } 
        }
        AppContext.showSpinner();
        Axios.dataAccess({
            url: "system/mbras/new/select-mbras-new-list.do",
            methodType: "post",
            paramType : "json",
            paramData : {
                // keyword       : keyword,
                searchAtrzSttsCd: searchAtrzSttsCd,
                upOgnzCd      : ognzCd === "00_000" ? "" : upOgnzCd,
                ognzCd        : ognzCd.includes("000") ? "" : ognzCd, // 지방본부(000): 해당 지방본부만
                ocptTypeCd    : ocptTypeCd,
                sttDt         : sttDt,
                endDt         : endDt,
            },
            onSuccessFn: (res: any) => {
              setDataArr(res.result.list);
                AppContext.hideSpinner();
            },
        });
    }, [callTime, searchAtrzSttsCd, upOgnzCd, ognzCd, ocptTypeCd, sttDt, endDt]);


    return (
        <div className="w1200 bgcWhite p20 bdrd8 mt10 boxShadowSoft">

        {/* 타이틀 */}
        <div className="mt5">
            <span className="posR dpBlock w100p fm-c fs25 fc2c3e50 ls1 pb10">조합원 등록/수정</span>
            <div className="bdt3 bdc007bff pb10"></div>
        </div>

        {/* 검색 조건 */}
        <div className="bd1 bdcDDDDDD p20 mb10 bdrd6 bgcFAFAFA">
            <div className="dpFlx aiC gap14 flxWrap">
                {/* 성명/조합원 번호 */}
                <div className="dpFlx aiC">
                    <span className="w40 fm-c fs15 fc333333 ls1 taL">성명</span>
                    <TextBox value={keyword}
                        width={120} height={36} fontSize={14}
                        fontFamily="fm-c" color="#333" letterSpacing={-1}
                        borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                        style={{ backgroundColor: "#fff", padding: "0 10px" }}
                        placeholder="성명 입력"
                        onChangeFunc={(text: string) => setKeyword(text)}
                    />
                </div>

                {/* 상태 */}
                <div className="dpFlx aiC">
                    <span className="w40 fm-c fs15 fc333333 ls1 taL ">상태</span>
                    <SelectBox value={searchAtrzSttsCd}
                        width={100} height={36} fontSize={14}
                        fontFamily="fm-c" color="#333" letterSpacing={-1}
                        borderColor="#ddd" borderOnColor="#222" borderRadius={2} background="#fff"
                        codeArray={[{code: "", name: "전체"}].concat(Util.getCodeArray("UI_ATRZ_STTS_CD_01"))}
                        placeholder="전체" paddingRight={8}
                        onChangeFunc={(data: string) => setSearchAtrzSttsCd(data)}
                    />
                </div>

                {/* 직종 */}
                <div className="dpFlx aiC">
                    <span className="w40 fm-c fs15 fc333333 ls1 taL">직종</span>
                    <SelectBox value={ocptTypeCd}
                        width={150} height={36} fontSize={14} fontFamily="fm-c" color="#333"
                        letterSpacing={-1} borderColor="#ddd" borderOnColor="#222"
                        borderRadius={2} background="#fff"
                        codeArray={[{code: "", name: "전체"}].concat(Util.getCodeArray("OCPT_TYPE_CD"))}
                        placeholder="전체" paddingRight={8}
                        onChangeFunc={(data: string) => setOcptTypeCd(data)}
                    />
                </div>

                {/* 작성일자 기간 */}
                <div className="dpFlx aiC">
                    <span className="w70 fm-c fs15 fc333333 ls1 taL">작성일자</span>
                    <DatePickerBox
                        width={150} height={36} fontSize={14}
                        fontFamily="fm-c" color="#333" letterSpacing={-1}
                        borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                        bgColor="white" textAlign="left" calendarThemeColor={AppContext.themeColor}
                        className="mr5" value={sttDt}
                        onChange={(data: string) => setSttDt(data)}
                    />
                    <span className="fm-c fc666666 mr5">~</span>
                    <DatePickerBox
                        width={150} height={36} fontSize={14}
                        fontFamily="fm-c" color="#333" letterSpacing={-1}
                        borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                        bgColor="white" textAlign="left" calendarThemeColor={AppContext.themeColor}
                        className="mr5" value={endDt}
                        onChange={(data: string) => setEndDt(data)}
                    />
                </div>

                {/* 초기화 버튼 */}
                <div className="dpFlx aiC mlA">
                    <Button
                        width={75} height={40} fontFamily="fm-b"
                        fontSize={16} letterSpacing={-1} 
                        variant="styInitBtn" borderRadius={6}
                        buttonClass="dpFlx aiC jcC" buttonName="초기화"
                        onClickFunc={() => {
                            setKeyword("");
                            setSearchAtrzSttsCd("");
                            setOcptTypeCd("");
                            setSttDt("");
                            setEndDt("");
                        }}
                    />
                </div>
            </div>
        </div>

        

        {/* =========================================================
            목록 헤더 영역(좌: 타이틀 / 우: 신규 등록 버튼)
            ========================================================= */}
        <div className="dpFlx aiC jcSb mb10 h44">
            <div className="fm-b fs16 fc007bff ls1 fw700">
                <span>조합원 목록</span>
            </div>

            {/* 신규 조합원 등록(모달 오픈) */}
            <Button
                width={150} height={40} fontFamily="fm-b"
                fontSize={16} letterSpacing={-1} 
                variant="styCompleteBtn" borderRadius={6}
                buttonClass="dpFlx aiC jcC" buttonName="신규 조합원 등록"
                onClickFunc={() => {
                    // if (ognzCd === "00_000") {
                    //     AppContext.openAlert({
                    //     title: "등록 권한 안내",
                    //     msg: "조합본부 관리자는 조합원 등록을 진행할 수 없습니다.",
                    //     icon: "warning",
                    //     });
                    //     return;
                    // }
                    // 지부인 경우만 등록 모달 오픈
                    setMbrasAtrzDocId("");
                    setModalOpen(true);
                }}
            />
        </div>

        {/* ==================== 조합원 리스트 =====================*/}
        <GridTable tableInfo={{
            tableHeadVsb: true, styleType: AdminGridStyle,
            fldInfs: fldInfs,
            ordFld: { name: "mbrasId", direction: "desc" }, // 기본 정렬
            dataArr: Util.filterFieldData(dataArr, fldInfs, "mbrasNm", keyword),
            maxRowNums: [10, 20, 30], // 페이지당 행 수 옵션
            theadTrHeight: 40, tbodyTrHeight: 35, paginateClass: "pt10",
            paginateStyle: {
                buttonOnColor: AppContext.boardThemeColor, buttonWidth: 22,
                buttonHeight: 24, buttonMarginLeft: 1, buttonMarginRight: 1,
                fontSize: 13, color: "#666666", letterSpacing: -0.8,
                fontFamily: "Pretendard-Regular", borderRadius: 3,
            },
            footerVsb: true,
            rowClickFunc: (item: any) => {  // 행 클릭 -> 상세 조회 -> 수정 모달 오픈
                setMbrasAtrzDocId(item.mbrasAtrzDocId);
                setMbrasId(item.mbrasId);
                setModalOpen(true);
            }
        }} />

        {/* 조합원 등록/수정 모달 */}
        <Modal modalOpen={modalOpen} dim={true} visible={true}
            titleEl={<DialogTitleBar title={Util.isEmpty(mbrasAtrzDocId) ? "조합원 등록" : "조합원 수정"} backgroundColor={AppContext.themeColor} />}
            onCloseFunc={() => {
                setMbrasAtrzDocId("");
                setMbrasId("");
                setModalOpen(false);
            }}
         >
            <div className="h900">
                <MbrasNewMngDialog mbrasAtrzDocId={mbrasAtrzDocId} mbrasId={mbrasId} setModalOpen={setModalOpen} setCallTime={setCallTime}/>
            </div>
        </Modal>
        </div>
    );
}

export default MbrasNewMng;
 